exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ele-textbox[data-v-1ce588fe] {\n  width: 100px;\n}\n.ele-textbox .ele-textbox-input[data-v-1ce588fe] {\n  padding-top: 0;\n  text-align: right;\n}\n.page-sub-header[data-v-1ce588fe] {\n  position: relative;\n  width: 100%;\n  min-height: 1px;\n  display: flex;\n  justify-content: space-between;\n}", ""]);

// exports
